import { atom } from 'recoil';
import { AcademyTableFiltersState } from '../../types/navigation';


export const initialAcademyTableFiltersState: AcademyTableFiltersState = {
  nameSearchString: '',
  selectedBirthYear: [],
  selectedContractStatus: [],
  selectedTeamIds: [],
  selectedPositions: [],
  selectedAcademyRoles: [],
  tableSortBy: undefined,
};


export const academyTableFiltersState = atom<AcademyTableFiltersState>({
  key: 'academyTableFilters',
  default: initialAcademyTableFiltersState,
});
